import { render } from "./IpSetter.vue?vue&type=template&id=190184ed"
import script from "./IpSetter.vue?vue&type=script&lang=js"
export * from "./IpSetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__